<template>
  <div class="user-dashboard-wrapper">
    <h1 class="heading squiggly-line-color">
      My Courses
    </h1>
    <div class="subscribed-courses" v-if="getUserRole === 'student'">
      <b-row v-if="getSubscribedCourses.length > 0">
        <b-col
          cols="3"
          v-for="course in getSubscribedCourses"
          :key="course.name"
        >
          <course-template :courseData="course" />
        </b-col>
      </b-row>
      <b-row v-else>
        <no-content
          :button-text="buttonTextStudent"
          :message="message"
          :is-course="true"
          :is-teacher="false"
        />
      </b-row>
    </div>
    <h1
      class="heading squiggly-line-color mt-4"
      v-if="getUserRole === 'student'"
    >
      Subscribed Live Courses
    </h1>
    <div class="upcoming-live mt-3" v-if="getUserRole === 'student'">
      <div class="live-tab" v-if="getSubscribedLiveCourses.length > 0">
        <banner-slider :slides="3" :liveCourses="getSubscribedLiveCourses" />
      </div>
      <div v-else>
        <no-content
          :button-text="buttonTextLive"
          :message="message"
          :is-course="false"
          :is-teacher="false"
          :is-live="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CourseTemplate from "../components/Templates/CourseTemplate";
import BannerSlider from "../components/Templates/BannerSlider";
import NoContent from "../components/Templates/NoContent";
export default {
  name: "my-courses",
  computed: {
    ...mapGetters("user", [
      "getUserDetails",
      "getUserRole",
      "getSubscribedLiveCourses",
      "getSubscribedCourses",
      "getTeacherCourses",
      "getTeacherLiveCourses"
    ])
  },
  data() {
    return {
      buttonTextStudent: "View All Courses",
      buttonTextLive: "View All Live Courses",
      buttonTextTeacher: "Add New Course",
      message: " No Courses Yet"
    };
  },
  components: {
    NoContent,
    CourseTemplate,
    BannerSlider
  }
};
</script>

<style scoped></style>
